import { observer } from 'mobx-react-lite';
import { Container, Menu } from 'semantic-ui-react';

export default observer(function HomeSideBar() {
    return (
        <Menu 
            vertical 
            borderless
            className='home-sidebar'
        >
            <Container>
                <Menu.Item header className='home-sidebar-h2' as={'h2'}>
                QUICK LINKS:
                </Menu.Item>
                
                {/* <Menu.Item target='_blank' href='https://wsdot.wa.gov/ferries/infodesk/faq/victoria'>
                    Traveling to Victoria
                </Menu.Item> */}
                <Menu.Item target='_blank' href='http://www.wsdot.wa.gov/ferries/fares/'>
                    Fares
                </Menu.Item>
                <Menu.Item target='_blank' href='http://www.wsdot.wa.gov/ferries/pdf/WashingtonStateFerries-RouteMap.pdf'>
                    Route Maps
                </Menu.Item>
                <Menu.Item target='_blank' href='http://www.wsdot.wa.gov/ferries/vesselwatch/terminals.aspx'>
                    Find Terminals
                </Menu.Item>
                <Menu.Item target='_blank' href='http://www.wsdot.wa.gov/ferries/vesselwatch/cameradetail.aspx'>
                    Ferry Cameras
                </Menu.Item>
                <Menu.Item target='_blank' href='https://wsdot.com/Travel/Real-time/Map/'>
                    Commuter Center
                </Menu.Item>
                <Menu.Item target='_blank' href='https://wsdot.wa.gov/Ferries/RouteAlerts'>
                    Ferry Alerts
                </Menu.Item>
            </Container>
        </Menu>
    )
})